<script>
import { Cell, Popup, Grid, GridItem, Image } from 'vant'
import Game from '@/tbs/model/vo/Game'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-team-suit-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-grid': Grid,
        'van-grid-item': GridItem,
        'van-image': Image,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label:String,
        value: String,
        disabled: Boolean,
        readonly: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['change-data', 'show-popup'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            selectedOptionUrl: null,
            suitList: []
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
        optionUrl() {
            let selectedUrl = ''
            if (this.selectedOptionUrl) {
                selectedUrl = this.selectedOptionUrl
            }
            else if (this.value) {
                for (let i = 0; i < this.suitList.length; i++) {
                    let item = this.suitList[i]
                    if (item.value === this.value) {
                        selectedUrl = item.url
                        break
                    }
                }
            }
            return selectedUrl
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {    
        onOptionLinkClick() {
            console.log('@onOptionLinkClick')
            if (!this.readonly && !this.disabled) {
                this.showPopup = true
                this.$emit('show-popup', true)
            }
        },
        onOptionItemClick(item) {
            this.selectedOptionUrl = item.url
            this.showPopup = false
            this.$emit('change-data', item)
            this.$emit('show-popup', false)
        },
    },

    created() {
        this.suitList = (new Game).suitList
    },
}
</script>

<template>
    <!-- component -->
    <div class="game-team-suit-selector van-cell no-padding">
        <van-cell 
            :title="label"
            :class="{ disabled: disabled }"
            :is-link="!readonly"
            center
            @click="onOptionLinkClick"
        >
            <template #default style="height: 24px;">
                <van-image 
                    v-if="optionUrl"
                    :src="optionUrl" 
                    width="24px" 
                    height="24px"
                />
            </template>
        </van-cell>
        <van-popup 
            v-model="showPopup" 
            position="bottom"
            :overlay="false"
            :duration="0" 
            @click="showPopup = false"
        >
            <div class="suit-grid-wrapper">
                <van-grid class="bg-white" :border="false" :column-num="8">
                    <van-grid-item 
                        v-for="item in suitList" 
                        :key="item.value"
                        @click.stop="onOptionItemClick(item)">
                        <van-image :src="item.url" width="20px" height="20px"/>
                    </van-grid-item>
                </van-grid>
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.game-team-suit-selector .van-cell__value {
    height: 24px;
}
.suit-grid-wrapper {
    height: calc(100vh - 46px);
    background-color: #F2F3F5;
}
</style>